<template>
  <div class="meeting-detail-page">
    <SubPageHeader title="会议详情" />
    <div class="content">
      <div v-if="isLoading" class="state-text">加载中...</div>
      <div v-else-if="!detailData" class="state-text">暂无会议详情数据</div>
      <div v-else class="detail-card">
        <div class="detail-item" v-for="item in detailItems" :key="item.label">
          <div class="detail-label">{{ item.label }}</div>
          <div class="detail-value">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMeetingDetail } from '@/api';
import toast from '@/components/toast';
import SubPageHeader from '../component/SubPageHeader.vue';

const DETAIL_PARAM_KEYS = ['id', 'meeting_id', 'record_id'];

export default {
  name: 'MeetingDetailPage',
  components: {
    SubPageHeader
  },
  data() {
    return {
      isLoading: false,
      detailData: null
    };
  },
  computed: {
    detailItems() {
      const detail = this.detailData || {};
      return [
        {
          label: '会议标题',
          value: detail.title || detail.meeting_title || detail.name || '三会一课'
        },
        {
          label: '会议类型',
          value: detail.meeting_type_name || detail.meeting_type || detail.type_name || '--'
        },
        {
          label: '主持人',
          value: detail.host_name || detail.moderator_name || '--'
        },
        {
          label: '会议时间',
          value: detail.meeting_time || detail.start_time || '--'
        },
        {
          label: '会议地点',
          value: detail.location || detail.place || '--'
        },
        {
          label: '会议内容',
          value: detail.content || detail.description || detail.remark || '--'
        }
      ];
    }
  },
  mounted() {
    this.fetchMeetingDetail();
  },
  methods: {
    buildDetailParams() {
      const params = {};
      DETAIL_PARAM_KEYS.forEach((key) => {
        const value = this.$route.query?.[key];
        if (value !== undefined && value !== null && value !== '') {
          params[key] = value;
        }
      });
      return params;
    },
    normalizeDetail(payload) {
      if (!payload) {
        return null;
      }
      if (Array.isArray(payload)) {
        return payload[0] || null;
      }
      return payload?.detail || payload?.info || payload;
    },
    async fetchMeetingDetail() {
      const params = this.buildDetailParams();
      this.isLoading = true;
      try {
        const res = await getMeetingDetail(params);
        this.detailData = this.normalizeDetail(res?.data);
      } catch (error) {
        this.detailData = null;
        if (Object.keys(params).length === 0) {
          toast('缺少详情参数，请从列表进入详情');
        }
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.meeting-detail-page {
  min-height: 100vh;
  background: #ffffff;
}

.content {
  padding: 3.58974vw;
}

.state-text {
  padding: 10.25641vw 0;
  text-align: center;
  color: #999;
  font-size: 3.84615vw;
}

.detail-card {
  background: #fff;
  border-radius: 3.07692vw;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.detail-item {
  padding: 4.10256vw 3.58974vw;
  border-bottom: 0.25641vw solid #f2f2f2;
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 3.58974vw;
  color: #999;
}

.detail-value {
  margin-top: 1.28205vw;
  font-size: 4.10256vw;
  color: #1f1f1f;
  line-height: 1.6;
  word-break: break-all;
}
</style>
